package games.polyclub.frontend.store.shared

import games.polyclub.service.config.api.SecretString
import kotlinx.serialization.Serializable

@Serializable
data class RegisterPaymentProfileRequest(
    val brazilian: Boolean,
    val name: String,
    val lastName: String,
    val cpf: SecretString?,
    val email: SecretString,
    val captcha: SecretString,
    val agreeWithTerms: Boolean,
)
